import React from "react";
import ReactDOM from "react-dom/client";
import posthog from 'posthog-js';
import "./index.css";
import App from "./App";
import { scrubEvent } from "./lib/analyticsScrub";
import { trackWebPushOpen } from "./lib/analytics";

posthog.init('phc_vfkzq2nVgFsDXjdyye9vAF9rAWD7fS5Ny5jkXQkhvrdw', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  // The screen shows people's prayers, names and groups, so nothing here records it, whatever the PostHog project is set to.
  // The named events in lib/analytics.js are still counted. Turning recording on needs the privacy policy to say so first.
  disable_session_recording: true,
  // Every address in an event is cut down before it leaves: no query, no fragment, no claim or delegation token (lib/analyticsScrub.js).
  before_send: scrubEvent,
  // The app is one page that changes its address as people move about: count each move as a page view, not only the first page of a
  // visit (which is all PostHog counts by default). Safe now that addresses are cleaned before they leave. Automatic click tracking
  // stays on: Dennis decided that (2026-10-09), and a test keeps it so.
  capture_pageview: 'history_change',
});

// A tap on one of the website's push notifications opened this page (public/sw.js marks the address): count it, and take
// the mark off before the app reads the address (P0215).
trackWebPushOpen();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA + push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('SW registered:', reg.scope))
      .catch(err => console.warn('SW registration failed:', err));
  });
}
